import { AudioBackupAndRecoveryStatus } from "../common/actions/RecoveringActions";
import { IRealTimeTranscriptionConnection } from "../../backend/interfaces/IRealTimeTranscriptionConnection";
import { CreateDefaultRealTimeTranscriptionConnection } from "../../backend/factory/RealTimeTranscriptionConnectionFactory";
import { TranscriptionRoutePathNames } from "../routes";

/**
 * An uninitialized audio backup is usually a consequence of a failure to open an indexeddb database
 * This usually happens if the user has blocked third-party cookies or is out of disk-space
 * In either of these cases, fetching an auth token would also currently fail - since the authAPI relies on localStorage being available
 * Allowing the user to proceed from this point will allow them to generate a recording/select a file to transcribe, but they would
 * fail uploading to OneDrive.
 * Whereas, we need OneDrive for both recording and the file upload scenarios. So, we will fail fast here - until the auth reliance on
 * localStorage gets fixed
 * (auth team says this should be fixed around Oct, 2020)
 * */
export function NavigateToLandingPageAfterAudioBackupCheck(backupAndState: AudioBackupAndRecoveryStatus, history: any) {
  const realTimeTranscriptionConnection: IRealTimeTranscriptionConnection = CreateDefaultRealTimeTranscriptionConnection();
  history.replace(TranscriptionRoutePathNames.Landing, {realTimeTranscriptionConnection, audioBackup: backupAndState.audioBackup});
}